import { render } from "./PickYearVidget.vue?vue&type=template&id=6ab97a16&scoped=true"
import script from "./PickYearVidget.vue?vue&type=script&lang=js"
export * from "./PickYearVidget.vue?vue&type=script&lang=js"

import "./PickYearVidget.vue?vue&type=style&index=0&id=6ab97a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab97a16"]])

export default __exports__